import { useEffect, useState } from 'react';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { BoardSetting } from './BoardSetting';
import { RevealAnimation } from './Animations';

export function SortableBoardSetting(props) {
  const {
        attributes,
        listeners,
        setNodeRef,
        transform,
        transition,
  } = useSortable({id: props.id});
  
  const [data, setData] = useState([]);

  useEffect(() => {
    if ( props.data ) {
        setData(props.data);
    }
  }, [props]);

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
  };

  const renderContent = () => {
    return (
        <li className="settings__list-item settings__list-item--boards" ref={setNodeRef} style={style} >
            <BoardSetting
                data={data} 
                parentEditMode={props.parentEditMode } 
                boardTypes={props.boardTypes ? props.boardTypes : []} 
                sortData={{attributes: attributes, listeners: listeners}}
                controller={props.controller}
            />
        </li>
    )
  }

    return (
        data.animate ? 
        <RevealAnimation>
            {renderContent()}
        </RevealAnimation>
        :
        renderContent()
    );
}
